import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { number } from 'prop-types';
import { AxiosResponse } from 'axios';
import { withNavigate } from '../authentication/pages/navigateWrapper';
import Navbar from "../../shared/components/navbar";
import Sidebar from "../../shared/components/sidebar";
import { Product } from '../../shared/interfaces/model/product.interface';
import { PaidProductDetails } from '../../shared/interfaces/model/tenant.interface';
import apiClient from '../../store/shared/api/apiClient';
import { ErroObj } from '../../shared/interfaces/model/errorObj.interface';
import { ApiErrorHandler } from '../../../errorHandler';
import { useLocation } from 'react-router-dom';

const sendInfoRequest = async (body: any) => {
    const object = {
        requestInfo: true,
        name: body.name,
        lastname: body.lastname,
        email: body.email,
        question: body.question,
        product: "Nexcode",
    };

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const URL = `${baseUrl}/nexum-saas/sendInvoiceEmail`;

    return apiClient
        .post(URL, object)
        .then((response: AxiosResponse) => response)
        .catch((e: ErroObj) => {
            ApiErrorHandler(
                e.message,
                e.config.url,
                JSON.stringify(e.config.headers),
                e.config.method
            );
        });
};

const nexbotBasic: Product = {
    id: "string",
    name: "Nexbot",
    desc: "Basic",
    appUrl: "appUrl",
    appCode: "lemmughvsxbfl3vnsxo",
    created_at: new Date(),
    price: 10.99,
};

const nexbotPro: Product = {
    id: "string",
    name: "Nexbot",
    desc: "Pro",
    appUrl: "appUrl",
    appCode: "lemmughvsxbfl3vnsxo",
    created_at: new Date(),
    price: 19.99,
};

const nexbotEnterprise: Product = {
    id: "string",
    name: "Nexbot",
    desc: "Enterprise",
    appUrl: "appUrl",
    appCode: "lemmughvsxbfl3vnsxo",
    created_at: new Date(),
    price: 50.00,
};

const nexbotPaidProductDetails: PaidProductDetails = {
    productAppCode: "lemmughvsxbfl3vnsxo",
    expireDate: new Date().toString(),
};

const nexcodeBasic: Product = {
    id: "string",
    name: "nexcode",
    desc: "Basic",
    appUrl: "appUrl",
    appCode: "4x21jZmnA0TNzZfA3i3l",
    created_at: new Date(),
    price: 10.99,
};

const nexcodePro: Product = {
    id: "string",
    name: "nexcode",
    desc: "Pro",
    appUrl: "appUrl",
    appCode: "4x21jZmnA0TNzZfA3i3l",
    created_at: new Date(),
    price: 19.99,
};

const nexcodeEnterprise: Product = {
    id: "string",
    name: "nexcode",
    desc: "Enterprise",
    appUrl: "appUrl",
    appCode: "4x21jZmnA0TNzZfA3i3l",
    created_at: new Date(),
    price: 50.00,
};

const nexcodePaidProductDetails: PaidProductDetails = {
    productAppCode: "4x21jZmnA0TNzZfA3i3l",
    expireDate: new Date().toString(),
};

const UpgradeTierPage = () => {
    const location = useLocation();
    const { tierBought, product } = location.state || {};
    const navigate = useNavigate();
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [tier, setTier] = useState<number | null>(null);
    const [showPurchaseButton, setShowPurchaseButton] = useState(false);
    const [isRequestPopupOpen, setRequestPopupOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        email: '',
        question: '',
    });

    useEffect(() => {
        const isTenantUser = localStorage.getItem("isTenantUser");
        setShowPurchaseButton(isTenantUser !== "true");
    }, []);

    const handlePayNowClick = (selectedTier: string) => {
        if (selectedTier === "Basic") {
            setTier(1);
        } else if (selectedTier === "Pro") {
            setTier(2);
        } else if (selectedTier === "Enterprise") {
            setTier(3);
        }
        setPopupOpen(true);
    };

    const handleRequestInformationClick = (selectedTier: string) => {
        setRequestPopupOpen(true);
    };

    const handleSendRequest = async () => {
        const { name, lastname, email, question } = formData;
        await sendInfoRequest({
            name,
            lastname,
            email,
            question,
        });
        alert('La tua richiesta è stata inviata con successo!');
        handleRequestPopupClose();
    };

    const handleRequestPopupClose = () => {
        setRequestPopupOpen(false);
    };

    const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handlePopupClose = () => {
        setPopupOpen(false);
        setIsChecked(false);
    };

    const handleContinue = () => {
        // Redirige solo se la checkbox è selezionata
        if (isChecked) {
            if (product == "Nexbot") {
                if (tier === 1) {
                    navigate(`/private/checkoutPage/${nexbotBasic.appCode}`, {
                        state: { product: nexbotBasic, paidProductInfo: nexbotPaidProductDetails },
                    });
                } else if (tier === 2) {
                    navigate(`/private/checkoutPage/${nexbotBasic.appCode}`, {
                        state: { product: nexbotPro, paidProductInfo: nexbotPaidProductDetails },
                    });
                } else if (tier === 3) {
                    navigate(`/private/checkoutPage/${nexbotBasic.appCode}`, {
                        state: { product: nexbotEnterprise, paidProductInfo: nexbotPaidProductDetails },
                    });
                }
            } else {
                if (tier === 1) {
                    navigate(`/private/checkoutPage/${nexcodeBasic.appCode}`, {
                        state: { product: nexcodeBasic, paidProductInfo: nexcodePaidProductDetails },
                    });
                } else if (tier === 2) {
                    navigate(`/private/checkoutPage/${nexcodeBasic.appCode}`, {
                        state: { product: nexcodePro, paidProductInfo: nexcodePaidProductDetails },
                    });
                } else if (tier === 3) {
                    navigate(`/private/checkoutPage/${nexcodeBasic.appCode}`, {
                        state: { product: nexcodeEnterprise, paidProductInfo: nexcodePaidProductDetails },
                    });
                }
            }
            setPopupOpen(false);
        }
    };

    return (
        <PageWrapper>
            {isRequestPopupOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-70 flex justify-center items-center">
                    <div className="bg-white p-8 rounded-lg shadow-lg">
                        <h2 className="text-2xl font-bold mb-6 text-blue-700">Richiedi Informazioni</h2>
                        <form>
                            <div className="mb-4">
                                <label className="block text-gray-700">Name:</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleFormChange}
                                    className="w-full border rounded p-2"
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700">Lastname:</label>
                                <input
                                    type="text"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleFormChange}
                                    className="w-full border rounded p-2"
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700">Email:</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleFormChange}
                                    className="w-full border rounded p-2"
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block text-gray-700">Info:</label>
                                <textarea
                                    name="question"
                                    value={formData.question}
                                    onChange={handleFormChange}
                                    className="w-full border rounded p-2"
                                />
                            </div>
                            <div className="flex justify-end space-x-4">
                                <PurchaseButton onClick={handleRequestPopupClose}>
                                    CANCEL
                                </PurchaseButton>
                                <PurchaseButton onClick={handleSendRequest}>
                                    INVIA RICHIESTA
                                </PurchaseButton>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {isPopupOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-70 flex justify-center items-center">
                    <div className="bg-white p-8 rounded-lg shadow-lg transition-transform transform scale-100 hover:scale-105">
                        <h2 className="text-2xl font-bold mb-4 text-indigo-600">Conferma Pagamento</h2>
                        <p className="mb-4 text-gray-700">Assicurati di leggere le informazioni prima di procedere con il pagamento.</p>
                        <div className="my-4 flex items-center">
                            <label htmlFor="terms-checkbox" className="text-gray-700">
                                <input
                                    type="checkbox"
                                    id="terms-checkbox"
                                    className="mr-2 h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                    checked={isChecked}
                                    onChange={(e) => setIsChecked(e.target.checked)}
                                />
                                Accept terms and conditions
                            </label>
                        </div>
                        <div className="flex justify-end space-x-4">
                            <PurchaseButton onClick={handlePopupClose}>
                                CANCEL
                            </PurchaseButton>
                            <PurchaseButton
                                onClick={handleContinue}
                                disabled={!isChecked}
                            >CONTINUE
                            </PurchaseButton>
                        </div>
                    </div>
                </div>
            )}
            <Sidebar />
            <MainContent>
                <Navbar />
                <Container>
                    <Title>Seleziona il tuo nuovo piano per {product}</Title>
                    <PlansContainer>
                        <PlanCard>
                            <PlanTitle>Basic</PlanTitle>
                            <Price>$15/mese</Price>
                            {tierBought === "Basic" && <PurchasedNotice>Versione acquistata</PurchasedNotice>}
                            <FeaturesList>
                                <Feature active>✓ Accesso a tante belle cose</Feature>
                                <Feature active>✓ Supporto via email</Feature>
                                <Feature>✗ Analisi avanzate</Feature>
                                <Feature>✗ Integrazioni IPA</Feature>
                            </FeaturesList>
                            <PurchaseButton onClick={() => handlePayNowClick("Basic")}>
                                Esegui l'upgrade
                            </PurchaseButton>
                        </PlanCard>

                        <PlanCard>
                            <PlanTitle>Pro</PlanTitle>
                            <Price>$29.99/mese</Price>
                            {tierBought === "Pro" && <PurchasedNotice>Versione acquistata</PurchasedNotice>}
                            <FeaturesList>
                                <Feature active>✓ Accesso a tante belle cose</Feature>
                                <Feature active>✓ Supporto prioritario</Feature>
                                <Feature active>✓ Analisi avanzate molto</Feature>
                                <Feature>✗ Integrazioni IPA</Feature>
                            </FeaturesList>
                            {tierBought === "Basic" && (
                                <PurchaseButton onClick={() => handlePayNowClick("Pro")}>
                                    Esegui l'upgrade
                                </PurchaseButton>
                            )}
                        </PlanCard>

                        <PlanCard>
                            <PlanTitle>Enterprise</PlanTitle>
                            <Price>$50/mese</Price>
                            <FeaturesList>
                                <Feature active>✓ Accesso a tante belle cose</Feature>
                                <Feature active>✓ Supporto dedicato</Feature>
                                <Feature active>✓ Analisi avanzate</Feature>
                                <Feature active>✓ Integrazioni IPA</Feature>
                            </FeaturesList>
                            <PurchaseButton onClick={() => handleRequestInformationClick("Enterprise")}>
                                Richiedi informazioni per eseguire l'upgrade
                            </PurchaseButton>
                        </PlanCard>
                    </PlansContainer>
                </Container>
            </MainContent>
        </PageWrapper>
    );
};

export default (UpgradeTierPage);

const PurchasedNotice = styled.div`
    background-color: #d4edda; /* Verde chiaro */
    color: #155724; /* Verde scuro */
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    text-align: center;
`;

const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #e0f7fa;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 60px;
  
  /* Adattamento per schermi più grandi */
  @media (min-width: 768px) {
    padding: 40px;
  }
`;

const Title = styled.h1`
  font-size: 2rem; /* Font adattabile per schermi piccoli */
  margin-bottom: 20px;
  color: #333;
  padding-top: 20px;
  
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
`;

const PlansContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;

  /* Adattamento per schermi di medie e grandi dimensioni */
  @media (min-width: 768px) {
    justify-content: space-between;
    padding: 0 20px;
  }
`;

const PlanCard = styled.div`
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  padding: 20px;
  background: linear-gradient(
      to top,
      rgba(12, 51, 51, 0.9),
      rgba(100, 100, 100, 0.9)
    ),
    url('your-stripe-pattern-image-url');
  background-size: cover;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px 100px 100px 100px; /* Spaziatura laterale dinamica */
  color: #ffffff;

  @media (min-width: 768px) {
    margin: 10px 50px;
    max-width: 400px;
  }
`;

const PlanTitle = styled.h2`
  font-size: 1.5rem;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

const Price = styled.p`
  font-size: 1.2rem;
  color: #4a90e2;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  width: 100%;
  text-align: left;
  margin: 10px 0;
`;

const Feature = styled.li<{ active?: boolean }>`
  color: ${({ active }) => (active ? '#4caf50' : '#ff0055')};
  font-size: 1rem;

  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
`;

const PurchaseButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: #357ABD;
  }

  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
`;
